import { useQuery } from "@tanstack/react-query";
import { useAdminSession } from "@/hooks/useAdminSession";
import {
  listAllCompanies,
  getCompanyDetail,
  type ListAllCompaniesParams,
} from "./companies";

export const companyQk = {
  list: (params: ListAllCompaniesParams) => ["admin", "companies", "list", params] as const,
  detail: (companyId: string) => ["admin", "companies", companyId] as const,
};

export function useAdminCompanies(params: ListAllCompaniesParams) {
  const enabled = useAdminSession();
  return useQuery({
    queryKey: companyQk.list(params),
    enabled,
    queryFn: () => listAllCompanies(params),
  });
}

export function useAdminCompanyDetail(companyId: string | undefined) {
  const enabled = useAdminSession();
  return useQuery({
    queryKey: companyQk.detail(companyId ?? ""),
    enabled: enabled && !!companyId,
    queryFn: () => getCompanyDetail(companyId!),
  });
}